export const readFiltersExpanded = (storageKey) => {
  try {
    return window.localStorage.getItem(storageKey) === 'true';
  } catch (error) {
    return false;
  }
};

export const writeFiltersExpanded = (storageKey, expanded) => {
  try {
    window.localStorage.setItem(storageKey, expanded ? 'true' : 'false');
  } catch (error) {
    // The in-memory component state remains usable when storage is unavailable.
  }
};
